var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagementAddRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4165 2.29485C16.1525 2.29485 15.1279 3.31949 15.1279 4.58346C15.1279 5.84742 16.1525 6.87207 17.4165 6.87207C18.6804 6.87207 19.7051 5.84742 19.7051 4.58346C19.7051 3.31949 18.6804 2.29485 17.4165 2.29485ZM14.2051 4.58346C14.2051 2.80986 15.6429 1.37207 17.4165 1.37207C19.1901 1.37207 20.6279 2.80986 20.6279 4.58346C20.6279 6.35706 19.1901 7.79485 17.4165 7.79485C15.6429 7.79485 14.2051 6.35706 14.2051 4.58346Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 9.16985H4.125V8.24707H12.375V9.16985Z",
    fill: "#B41730"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2308 13.7471H4.125V14.6698H15.2308V13.7471Z",
    fill: "#B41730"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29485 4.12545C2.29485 3.61829 2.7013 3.21184 3.20846 3.21184H12.3751V2.28906H3.20846C2.19166 2.28906 1.37207 3.10865 1.37207 4.12545V18.7921C1.37207 19.8089 2.19166 20.6285 3.20846 20.6285H13.5387V19.7057H3.20846C2.7013 19.7057 2.29485 19.2993 2.29485 18.7921V4.12545ZM18.7887 16.2198H19.7115V9.62545H18.7887V16.2198Z",
    fill: "#B41730"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3078 18.6157H12.6924V17.7695H20.3078V18.6157Z",
    fill: "#B41730"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0771 22.0002V14.3848H16.9233V22.0002H16.0771Z",
    fill: "#B41730"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementAddRed);
export default __webpack_public_path__ + "static/media/management_add_red.74c0f009.svg";
export { ForwardRef as ReactComponent };